export const REFRESH_INTERVAL_STORAGE_KEY = "primio-monitor-refresh-interval";

export const REFRESH_INTERVAL_OPTIONS = [
  { value: 0, labelKey: "refresh.off" },
  { value: 15_000, labelKey: "refresh.15s" },
  { value: 30_000, labelKey: "refresh.30s" },
  { value: 60_000, labelKey: "refresh.1m" },
  { value: 300_000, labelKey: "refresh.5m" },
] as const;

export type RefreshIntervalMs =
  (typeof REFRESH_INTERVAL_OPTIONS)[number]["value"];

export function readRefreshInterval(): RefreshIntervalMs {
  try {
    const stored = Number(localStorage.getItem(REFRESH_INTERVAL_STORAGE_KEY));
    if (REFRESH_INTERVAL_OPTIONS.some((option) => option.value === stored)) {
      return stored as RefreshIntervalMs;
    }
  } catch {
    // ignore
  }
  return 30_000;
}

export function writeRefreshInterval(value: RefreshIntervalMs) {
  try {
    localStorage.setItem(REFRESH_INTERVAL_STORAGE_KEY, String(value));
  } catch {
    // ignore
  }
}
